import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

// The type of column in the report
export enum ColumnType {
  GROUP = 'GROUP',
  FIXED = 'FIXED',
  AGGREGATE = 'AGGREGATE',
}

// For numerical columns, the format in which the value should be displayed
export enum NumberFormat {
  CURRENCY = 'CURRENCY',
  PERCENTAGE = 'PERCENTAGE',
}

export const tagwallConfigurableReportXlsxFileDataCellSchema = yup.object({
  columnName: yup.string().notRequired(),
  type: yup.string().notRequired(),
  aggregationFunction: yup.string().notRequired(),
  order: yup.string().notRequired(),
  value: yup.string().notRequired(),
  numberFormat: yup.string().notRequired(),
})

// Define the schema for a single element of the array
export const tagwallConfigurableReportXlsxFileDataElementSchema = yup.object({
  cells: yup.array().of(tagwallConfigurableReportXlsxFileDataCellSchema),
})

// Define the schema for a single header
export const tagwallConfigurableReportXlsxFileHeaderElementSchema = yup
  .object({
    text: yup.string().notRequired(),
    order: yup.string().notRequired(),
  })
  .required()

export const tagwallConfigurableReportXlsxFileDataSchema = yup
  .object({
    worksheetName: yup.string().notRequired(),
    headers: yup.array().of(tagwallConfigurableReportXlsxFileHeaderElementSchema).required(),
    rows: yup.array().of(tagwallConfigurableReportXlsxFileDataElementSchema).required(),
  })
  .required()

export type TagwallConfigurableReportXlsxFileData = yup.InferType<
  typeof tagwallConfigurableReportXlsxFileDataSchema
>

// Type for a single element of the rows array
export type TagwallConfigurableReportXlsxFileDataElement = yup.InferType<
  typeof tagwallConfigurableReportXlsxFileDataElementSchema
>

// Type for a single cell
export type TagwallConfigurableReportXlsxFileDataCell = yup.InferType<
  typeof tagwallConfigurableReportXlsxFileDataCellSchema
>

// Type for a single header
export type TagwallConfigurableReportXlsxFileHeaderElement = yup.InferType<
  typeof tagwallConfigurableReportXlsxFileHeaderElementSchema
>

// Use the element type for the mappings
type RequiredFileData = MakeRequiredAndNullable<TagwallConfigurableReportXlsxFileData>

const cellMappings: MakeRequiredAndNullable<TagwallConfigurableReportXlsxFileDataCell> = {
  columnName: 'bec85a4e-a444-46b2-8e7f-a588b25c2ac0',
  type: '08a7e5fe-e984-451c-b776-010b476ef127',
  aggregationFunction: 'e6e38ed0-74aa-45cd-a7f2-0b788233541d', // Only for aggregate columns
  order: '2b64ed45-60c7-48ab-9aa1-b2b05822c99f',
  value: 'bf91728f-b1fc-4209-b4b4-0ff55ea763e4',
  numberFormat: '77934f32-57bb-47ce-8129-b8bacf4265b2', // Only for numerical columns
}

const rowMappings: MakeRequiredAndNullable<TagwallConfigurableReportXlsxFileDataElement> = {
  cells: [cellMappings],
}

const headerMappings: MakeRequiredAndNullable<TagwallConfigurableReportXlsxFileHeaderElement> = {
  text: '5225dd37-34ef-485d-9aec-bd822401b7bc',
  order: 'ac8218c5-d9a6-4103-b3c4-c8d0f656d0ee',
}

export const tagwallConfigurableReportXlsxFileMappings: RequiredFileData = {
  worksheetName: 'c4f41bb3-3d44-4bc3-b025-22691e9fc99b',
  headers: [headerMappings],
  rows: [rowMappings],
}
